import {
  AssetFillState,
  AssetStatus,
  Weight,
} from '@rematter/frontend-lib-api-client';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

type AssetDetailRecord = {
  id: string;
  identifier: string;
  description: string;
  status: AssetStatus;
  fillState: AssetFillState;
  notes: string | null;
  type: {
    id: string;
    name: string;
    description: string;
    capacity: number | null;
  };
  account: { id: string; name: string } | null;
  facility: { id: string; facilityName: string } | null;
  accountAddress: { id: string; name: string | null } | null;
  currentLocation: {
    streetAddress: string | null;
    city: string | null;
    state: string | null;
    postalCode: string | null;
    country: string | null;
    coordinates: { latitude: number; longitude: number } | null;
  } | null;
  lastLocationTime: string | null;
  tareWeight: Weight | null;
  customAttributes: Record<string, unknown>;
  timestamps: { createdAt: string; updatedAt: string };
};

type AssetDetailResult = { assets: AssetDetailRecord[] };

export const assetDetailQueryAtom = createQueryAtomFactory(
  'transportation.assetDetail',
  (params: { ids: string[] }) => ({
    assets: {
      __args: {
        filter: {
          ids: params.ids,
        },
        pagination: {
          offset: 0,
          limit: 1,
        },
      },
      entries: {
        id: true,
        identifier: true,
        description: true,
        status: true,
        fillState: true,
        notes: true,
        type: {
          id: true,
          name: true,
          description: true,
          capacity: true,
        },
        account: {
          id: true,
          name: true,
        },
        facility: {
          id: true,
          facilityName: true,
        },
        accountAddress: {
          id: true,
          name: true,
        },
        currentLocation: {
          streetAddress: true,
          city: true,
          state: true,
          postalCode: true,
          country: true,
          coordinates: {
            latitude: true,
            longitude: true,
          },
        },
        lastLocationTime: true,
        tareWeight: {
          value: true,
          unit: true,
        },
        customAttributes: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (data): AssetDetailResult => ({
      assets: (data?.assets.entries ?? []) as AssetDetailRecord[],
    }),
  },
);
